<template>
  <div class="wai">
    <div class="title" style="margin-bottom: 20px;">
      <div style="flex: 1;">基本信息</div>
      <div style="position: relative">
        <el-button size="small" style="margin-right: 10px;" @click="handleTransfer">账号迁移</el-button>
        <el-button size="small" type="info" style="margin-right: 10px;"
                   @click="$router.push({ path: '/user_data'})">返回
        </el-button>
        <div style="position: absolute; top: 60px; right: 10px" v-if="user.transferTarget || user.receiveSource">
          <el-popover
            placement="left"
            title=""
            width="200"
            trigger="hover"
            style="line-height: 20px">
            <div
              v-if="user.transferTarget"
            >{{ user.transferTime }} 迁移至 {{ user.transferTarget }}</div>
            <div
              v-if="user.receiveSource"
            >{{ user.receiveTime }} 为 {{ user.receiveSource }} 迁移</div>
            <el-link slot="reference">迁移历史</el-link>
          </el-popover>
        </div>
      </div>
    </div>
    <!-- 第一部分 -->
    <div class="demo1">
      <div class="demo1_left">
        <div class="head">
          <el-avatar :size="80" src="../../../assets/head.png">
            <img :src="user.avatarUrl"/>
          </el-avatar>
          <el-tag size="small" v-if="user.transferTarget">曾迁移账号</el-tag>
          <el-tag size="small" type="danger" v-if="user.receiveSource">迁移账号</el-tag>
        </div>
        <div class="biaoq" v-if="user.isMeber == 1">
          会员
          <div style="color:#000; font-size: 12px">
            {{ user.memberExpiredTime }}到期
          </div>
        </div>
      </div>

      <div class="demo1_right">
        <table>
          <tr>
            <td style="background-color: #F5F7FA">用户ID</td>
            <td>{{ user.id }}</td>
            <td style="background-color: #F5F7FA">职业</td>
            <td>{{ user.career }}</td>
          </tr>
          <tr>
            <td style="background-color: #F5F7FA">昵称</td>
            <td>{{ user.nickName }}</td>
            <td style="background-color: #F5F7FA">城市</td>
            <td>{{ user.city }}</td>
          </tr>
          <tr>
            <td style="background-color: #F5F7FA">性别</td>
            <td>{{ user.gender }}</td>
            <td style="background-color: #F5F7FA">会员注册时间</td>
            <td>{{ user.joinMeberTime }}</td>
          </tr>
          <tr>
            <td style="background-color: #F5F7FA">手机号</td>
            <td>{{ user.telphone }}</td>
            <td style="background-color: #F5F7FA">注册时间</td>
            <td>{{ user.addTime }}</td>
          </tr>
          <tr>
            <td style="background-color: #F5F7FA">生日</td>
            <td>{{ user.born || '--' }}</td>
            <td style="background-color: #F5F7FA">CVIP有效期</td>
            <td>{{ user.joinMeberTime }} - {{ user.memberExpiredTime }}</td>
          </tr>
        </table>
      </div>
      <div style="margin-left: 20px; line-height: 45px">
        <div style="display: flex; align-items: center;">
          是否曾换号：
          <el-switch
            @change="edit()"
            v-model="user.isOldUser"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </div>
        <div style="display: flex; align-items: center;">
          加入黑名单：
          <el-switch
            @change="edit()"
            v-model="user.isDisable"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
          <el-tag
            v-if="user.isDisable === 1"
            type="danger"
            style="margin-left:10px;height:22px;line-height:20px;"
          >{{ user.disableTime }} 列入黑名单
          </el-tag>
        </div>
      </div>
    </div>
    <!-- 第二部分开始 -->
    <div class="title2">用户标签/所属人群</div>
    <div class="demo2">
      <div class="demo2_label" v-for="label in userLabels" :key="label.id">
        {{ label.labelName }}
        <div @click="claerLabel(label.id)">x</div>
      </div>
      <div class="demo2_add" @click="dialogVisible = true">
        + 添加标签
      </div>
    </div>
    <el-dialog title="添加标签" :visible.sync="dialogVisible" width="30%">
      <el-checkbox-group v-model="labelname">
        <div v-for="label in labelList" :key="label.id">
          <el-checkbox v-if="user.userLabels.indexOf(label.id+'') == -1" :label="label.id">
            {{ label.labelName }}
          </el-checkbox>
        </div>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false, addUserLabel()">确 定</el-button>
			</span>
    </el-dialog>
    <!-- 第三部分开始 -->
    <div class="title2">用户统计信息</div>
    <div class="demo3_table">
      <el-table :header-cell-style="{
          'background-color': '#F9FCFF',
          'text-align': 'center',
        }" :data="tableData" border lazy style="width: 100%">
        <el-table-column align="center" label="累计消费金额">
          <template slot-scope="scope"> ￥ {{ scope.row.consumeTotal }}</template>
        </el-table-column>
        <el-table-column align="center" prop="orderNumTotal" label="累计订单数量" width="180"></el-table-column>
        <el-table-column align="center" prop="consumeAvg" label="平均消费金额"></el-table-column>
        <el-table-column align="center" prop="integral" label="积分"></el-table-column>
        <el-table-column align="center" prop="exchangeNum" label="兑换次数"></el-table-column>
        <el-table-column align="center" prop="couponNum" label="优惠券(张)"></el-table-column>
        <el-table-column align="center" prop="useCouponNum" label="使用优惠券次数"></el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-table :header-cell-style="{
            'background-color': '#F9FCFF',
            'text-align': 'center',
          }" :data="tableData" border lazy style="width: 100%">
          <el-table-column align="center" label="消费最多门店/次">
            <template slot-scope="scope">
              {{ scope.row.consumeStore }} / {{ scope.row.consumeStoreNum }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="消费最多发型师/次" width="180">
            <template slot-scope="scope">{{ !scope.row.consumeWorker ? "无" : scope.row.consumeWorker }} /
              {{ scope.row.consumeWorkerNum }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="avgDate" label="平均剪发周期">
          </el-table-column>
          <el-table-column align="center" label="购买最多服务/次 ">
            <template slot-scope="scope">{{ scope.row.buyService }} /
              {{ scope.row.buyServiceNum }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="评价最多等级/次">
            <template slot-scope="scope">{{ scope.row.commentGood|commentFormat }} /
              {{ scope.row.commentGoodNum }}
            </template>
          </el-table-column>
          <el-table-column prop="serverNum" align="center" label="服务评价 "></el-table-column>
          <el-table-column align="center" prop="loginNum" label="登录次数"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 用户卡金 -->
    <c-card ref="ccardRef" :id="id"/>
    <!-- UVIP -->
    <u-vip ref="uvipRef" :id="id"/>
    <!-- 用户剩余券 -->
    <div class="title2" style="display: flex;flex-wrap: wrap;">用户剩余券
      <div v-for="item in couponInfo" style="margin-left: 30px;color: #aaa;">
        {{ item.title }}*{{ item.count }}张
      </div>
    </div>
    <div style="display: flex;flex-wrap: wrap;">
      <div v-if="userCoupon == null || userCoupon.length==0" style="font-size: 12px;">
        暂无优惠券
      </div>
      <div v-for="item in userCoupon" style="margin-right: 15px;">
        <el-tooltip :content="'优惠金额:' + item.reduction" placement="top-start">
          <el-tag closable="" @close="handleClose(item)">{{ item.title }}</el-tag>
        </el-tooltip>
      </div>
    </div>
    <!-- 会员信息 -->
    <div class="title2">会员信息</div>
    <el-table :cell-style="{ 'text-align': 'center' }"
              :header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }" ref="multipleTable"
              :data="memberOrderList" tooltip-effect="dark" style="width: 100%">
      <el-table-column prop="orderNo" label="订单编号"></el-table-column>
      <el-table-column prop="memberId" label="商品/服务">
        <template slot-scope="scope">
          {{ scope.row.memberId|memberFormat }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="类型">
            <template slot-scope="scope">
              {{ scope.row.type|memberTypeFormat }}
            </template>
          </el-table-column> -->
      <el-table-column prop="storeId" label="服务门店"></el-table-column>
      <el-table-column prop="money" sortable label="支付总额">
        <template slot-scope="scope"> ￥{{ (scope.row.money / 100).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="添加时间"></el-table-column>
      <el-table-column label="折扣">
        <template slot-scope="scope">
          {{ scope.row == memberOrderList[0] ? scope.row.memberDiscount : scope.row.memberId | memberDiscountFormat }}
        </template>
      </el-table-column>
      <el-table-column prop="dueDate" label="到期时间">
        <template slot-scope="scope">{{ scope.row == memberOrderList[0] ? scope.row.dueDate : "已到期" }}</template>
      </el-table-column>
      <el-table-column label="状态" sortable>
        <template slot-scope="scope">
          {{ scope.row.status|statusFormat }}
        </template>
      </el-table-column>
    </el-table>
    <!-- 订单信息 -->
    <div class="title2">订单信息
      <span style="color:#aaa;">
				{{ user.telphone }}
			</span>
    </div>
    <el-table :cell-style="{ 'text-align': 'center' }"
              :header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }" ref="multipleTable"
              :data="orderList"
              tooltip-effect="dark" style="width: 100%">
      <el-table-column prop="orderNo" label="订单编号"></el-table-column>
      <el-table-column prop="type" label="商品/服务"></el-table-column>
      <el-table-column label="订单类型">
        <template slot-scope="scope">
          {{ scope.row.orderType|typeFormat }}
        </template>
      </el-table-column>
      <el-table-column prop="rankNo" label="排队编号" width="85"></el-table-column>
      <el-table-column prop="storeName" label="服务门店"></el-table-column>
      <el-table-column prop="workerName" label="发型师"></el-table-column>
      <el-table-column label="支付方式">
        <template slot-scope="scope">
          {{ scope.row.payType ? scope.row.payType : "/" }}
        </template>
      </el-table-column>
      <el-table-column prop="total" sortable label="支付总额">
        <template slot-scope="scope"> ￥{{ (scope.row.payTotal / 100).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column align="center" prop="couponTitle" label="优惠劵">
        <template slot-scope="scope">
          {{ scope.row.couponTitle ? scope.row.couponTitle : '/' }}
        </template>
      </el-table-column>
      <el-table-column prop="addTime" label="订单创建时间" width="160"></el-table-column>
      <!-- 			<el-table-column label="渠道">
        <template slot-scope="scope">
          {{ scope.row.channel ? scope.row.channel : "无" }}
        </template>
      </el-table-column> -->
      <el-table-column label="状态" sortable width="80">
        <template slot-scope="scope">
          {{ scope.row.status ? scope.row.status : "/" }}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagescg">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="filter.page" :page-sizes="[10, 50, 100,200,500]" :page-size="filter.size"
                     layout="total, sizes, prev, pager, next" :total="filter.total">
      </el-pagination>
    </div>
    <!-- 账号迁移 -->
    <transfer @refresh="getInfo" ref="transfer"/>
  </div>
  <!-- 第三部分开始 -->
  <!-- <div class="title2">收货地址</div>
    <div>
      <el-table
        :header-cell-style="{
          'background-color': '#F9FCFF',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
        :data="user.addressList"
        border
        style="width: 100%"
      >
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="phone" label="手机号码" width="180"></el-table-column>
        <el-table-column prop="address" label="详细地址"> </el-table-column>
        <el-table-column prop="code" label="邮政编码"> </el-table-column>
        <el-table-column label="默认地址">
      <template slot-scope="scope">
              <el-radio disabled v-model="scope.row.isDefault" label="1">{{""}}</el-radio>
      </template>
        </el-table-column>
      </el-table>
    </div> -->

  <!-- 第三部分开始 -->
  <!-- <div class="title2">用户档案</div>
    <div>
      <el-table
        :header-cell-style="{
          'background-color': '#F9FCFF',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
        :data="userInfo"
        border
        style="width: 100%"
      >
        <el-table-column prop="hairstyle" label="发型偏好"></el-table-column>
        <el-table-column prop="age" label="年龄" width="180"></el-table-column>
        <el-table-column prop="career" label="社会身份"></el-table-column>
        <el-table-column prop="follow" label="注重潮剪的方面"> </el-table-column>
      </el-table>
    </div> -->
  <!-- 第三部分结束 -->
</template>
<script>
import transfer from "./transfer.vue"
import cCard from "./c_card.vue"
import uVip from "./uvip.vue"

export default {
  components: {
    transfer,
    cCard,
    uVip
  },
  data() {
    return {
      id: this.$route.query.id,
      user: {},
      userLabels: [],
      addLabelList: [],
      dialogVisible: false,
      labelname: [],
      //第三部分表格
      tableData: [{}],
      userInfo: [{}],
      labelList: [],
      userCoupon: [], //用户剩余券
      couponInfo: [], //剩余券及其数量
      orderList: [], //订单信息
      memberOrderList: [],
      allStoreList: [],
      filter: {
        endTime: "",
        startTime: "",
        time: "",
        page: 1,
        size: 10,
        total: 0
      },
    };
  },
  mounted() {
    this.getInfo();
    this.getStores();
    // this.getOrder();
  },
  filters: {
    commentFormat(val) {
      if (!val) return "无";
      switch (val) {
        case '1':
          return '非常不满意';
        case '2':
          return '不满意';
        case '3':
          return '一般';
        case '4':
          return '满意';
        case '5':
          return '非常满意';
      }
    },
    typeFormat(val) {
      let str = "普通订单"
      switch (val) {
        case "2":
          str = "企业剪订单";
          break;
        case "9":
          str = "美团订单";
          break;
        case "11":
          str = "会员权益订单";
          break;
      }
      return str;
    },
    statusFormat(val) {
      switch (val) {
        case 0:
          return '未支付';
        case 1:
          return '已支付';
        case 2:
          return '取消支付';
        default:
          return '/';
      }
    },
    memberFormat(val) {
      switch (val) {
        case 1:
          return '潮·特权';
        case 2:
          return '潮剪联名卡VIP';
        case 3:
          return '8折会员卡';
        case 4:
          return '9折会员卡';
        case 5:
          return '会员';
        default:
          return "其他"
      }
    },
    memberDiscountFormat(val) {
      switch (val) {
        case 1:
          return '85折';
        case 2:
          return '85折';
        case 3:
          return '8折';
        case 4:
          return '9折';
        case 5:
          return '10折';
        default:
          return "其他"
      }
    },
    memberTypeFormat(val) {
      switch (val) {
        case true:
          return '非续费订单';
        case false:
          return '续费订单';
        default:
          return "其他"
      }
    },
    nul(val) {
    }
  },
  methods: {
    // 修改用户信息
    edit() {
      let data = {
        id: this.id,
        isOldUser: this.user.isOldUser,
        isDisable: this.user.isDisable
      }
      this.$http.post("user/update", data).then(res => {
        this.getInfo();
        this.$message({
          type: "success",
          message: "修改成功!",
        });
      })
    },
    claerLabel(id) {
      this.$confirm("是否要删除该标签?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var data = {
          labelId: id,
          userId: this.id
        }
        this.$http.post("user/deleteLabel", data).then(res => {
          this.getInfo();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
      });
    },
    addUserLabel() {
      this.$http.get("user/setLabel?userId=" + this.id + "&labelIds=" + this.labelname).then((res) => {
        this.getInfo();
        this.labelname = [];
      })
    },
    getInfo() {
      this.$http.get("user/userData?userId=" + this.id).then((res) => {
        this.user = res.body.data;
        if (this.user.avatarUrl == null) {
          if (this.user.avatarUrl == undefined) {
            this.user.avatarUrl = '../../../assets/head.png'
          }
        }
        this.tableData = [res.body.data.userData]
        this.userCoupon = res.body.data.userData.coupon
        var coupons = []; //用户剩余券的所有券名数组
        for (let a in this.userCoupon) {
          coupons.push(this.userCoupon[a].title);
        }
        console.log(coupons)
        //将coupons数组划分为[{item:券名;count:数量}]=this.couponInfo
        var hashArr = [...new Set(coupons)];
        var list = [];
        hashArr.forEach((Element) => {
          list.push(coupons.filter(i => i == Element));
        });
        hashArr.forEach((item, index) => {
          this.couponInfo.push({
            title: item,
            count: list[index].length
          })
        })
        console.log(this.couponInfo)
        this.userInfo = [this.user]
        this.$http.get("user/label").then((res) => {
          var userLabelstotal = []
          this.labelList = res.body.data;
          var userLabels = this.user.userLabels.split(",")
          for (let i in this.labelList) {
            for (let j in userLabels) {
              if (userLabels[j] == this.labelList[i].id) {
                userLabelstotal.push(this.labelList[i])
              }
            }
          }
          this.userLabels = userLabelstotal
          // this.userLabels = this.labelList.map(label => {
          // 	if(this.user.userLabels && this.user.userLabels.indexOf(label.id+"") != -1) return label;
          // }).filter(l => l);
        });
      });
    },
    getOrder() {
      if (this.filter.times) {
        var arr = {
          time: "自定义",
          size: this.filter.size,
          page: this.filter.page,
          endTime: this.filter.times[1],
          startTime: this.filter.times[0],
          userId: this.id,
          orderStatus: '3,5'
        };
      } else {
        var arr = {
          size: this.filter.size,
          page: this.filter.page,
          userId: this.id,
          orderStatus: '3,5'
        };
      }
      this.$http.get("user/serverList", {
        params: arr
      }, {
        emulateJSON: true
      }).then(res => {
        if (res.body.code == 200) {
          this.orderList = res.body.data.rows;
          this.filter.total = res.body.data.total;
        } else {
          this.$message.error("订单信息请求失败");
        }
      })
      this.$http.get("dMemberOrder/memberOrderList?userId=" + this.id).then(res => {
        this.memberOrderList = []
        if (res.status = 200) {
          for (var j = 0; j < res.data.length; j++) {
            for (var x = 0; x < this.allStoreList.length; x++) {
              if (this.allStoreList[x].id == res.data[j].storeId) {
                res.data[j].storeId = this.allStoreList[x].title
                this.memberOrderList.push(res.data[j])
              }
            }
          }
        } else {
          this.$message.error("会员订单请求失败");
        }
      });
    },
    getStores() {
      this.$http.get("store/list").then(res => {
        res.body.data.forEach(ele => {
          this.allStoreList.push(ele)
        })
        this.getOrder()
      })
    },
    handleClose(item) {
      this.$confirm('删除该券, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var a = {
          id: item.id,
          userId: item.userId,
          couponTitle: item.title,
          code: item.code
        }
        console.log(a)
        this.$http.post("user/deleteCoupon", JSON.stringify(a)).then(res => {
          if (res.body.code == 200) {
            this.getInfo()
            this.$message.success("删除成功")
          } else {
            this.$message.success("删除失败")
          }
        })
      }).catch(() => {
        this.$message.success("已取消删除")
      });
    },
    handleSizeChange(val) {
      this.filter.size = val;
      this.getOrder();
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getOrder();
    },
    handleTransfer() {
      this.$nextTick(() => {
        this.$refs.transfer.show(this.user.id)
      })
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3e3e3e;
  display: flex;
  font-weight: bold;

  .blue {
    width: 5px;
    height: 15px;
    background: #409eff;
    border-radius: 2px;
    margin-right: 8px;
    position: relative;
    top: 4px;
  }
}

.title2 {
  margin-top: 30px;
  margin-bottom: 30px;
  font-weight: bold;
  font-size: 16px;
  font-family: Source Han Sans CN;
}

// 第一部分
.demo1 {
  width: 100%;
  display: flex;

  .demo1_left {
    width: 100px;

    .head {
      margin-top: 30px;
      width: 83px;
      //height: 83px;
      border-radius: 4px;
      text-align: center;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .biaoq {
      margin-left: 3px;
      margin-top: 5px;
      width: 74px;
      height: 27px;
      background: #3f3f3f;
      border-radius: 14px;
      text-align: center;
      line-height: 27px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #e4be9c;
    }
  }

  .demo1_right {
    margin-left: 20px;
    width: 60%;

    table {
      width: 100%;

      tr {
        width: 100%;
        display: flex;

        td {
          line-height: 40px;
          text-align: center;
          height: 40px;
          flex: 1;
        }
      }
    }
  }
}

// 第二部分
.demo2 {
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  padding-top: 10px;
  min-height: 150px;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #d3d3d3;

  .demo2_label {
    cursor: pointer;
    height: 23px;
    margin-top: 10px;
    padding: 10px;
    background: #ffffff;
    border: 1px solid #d3d3d3;
    position: relative;

    & {
      margin-right: 20px;
    }

    &:hover div {
      display: block;
    }

    div {
      display: none;
      text-align: center;
      line-height: 12px;
      font-size: 12px;
      color: #ffffff;
      border-radius: 50%;
      position: absolute;
      right: -5px;
      top: -5px;
      height: 15px;
      width: 15px;
      background-color: #000000;
    }
  }

  .demo2_add {
    height: 23px;
    margin-top: 10px;
    cursor: pointer;
    padding: 10px;
    background: #ffffff;
    border: 1px dashed #d3d3d3;
  }
}

/* 通用表格样式 */
table {
  border: 1px solid #EBEEF5; /* 添加边框 */

  tr {
    margin-bottom: 1px;
  }
}

</style>
